<template>
  <el-container class="admin-layout">
    <!-- 左侧导航栏 -->
    <el-aside class="sidebar">
      <!-- 系统logo区域 -->
      <div class="sidebar-logo">
        <el-icon class="logo-icon"><UserFilled /></el-icon>
        <span class="logo-text">基础配置</span>
      </div>

      <!-- 导航菜单 -->
      <el-menu
        default-active="1"
        class="sidebar-menu"
        background-color="transparent"
        text-color="#b0c8e8"
        active-text-color="#00ccff"
        @select="handleMenuSelect"
      >
        <el-menu-item index="1">
          <span slot="title">人脸库管理</span>
        </el-menu-item>
        <el-menu-item index="2">
          <span slot="title">设备管理</span>
        </el-menu-item>
        <el-menu-item index="3">
          <span slot="title">角色管理</span>
        </el-menu-item>
        <el-menu-item index="5">
          <span slot="title">区域管理</span>
        </el-menu-item>
        <el-menu-item index="4">
          <span slot="title">用户管理</span>
        </el-menu-item>
        <!-- 新增区域管理菜单 -->
      </el-menu>
    </el-aside>

    <!-- 右侧内容区域 -->
    <el-container class="main-container">
      <!-- 内容头部 -->
      <el-header class="content-header">
        <h2 class="content-title" v-text="currentTitle"></h2>
        <!-- 操作按钮区 -->
        <div class="content-actions">
          <el-button
            type="primary"
            v-if="currentMenu !== '1'"
            @click="handleAdd"
          >
            新增
          </el-button>
          <el-button
            type="primary"
            v-if="currentMenu === '1'"
            @click="handleImportFace"
          >
            批量导入
          </el-button>
          <el-button type="info" @click="handleRefresh"> 刷新 </el-button>
        </div>
      </el-header>

      <!-- 内容主体 -->
      <el-main class="content-body">
        <!-- 人脸库管理页面 -->
        <div v-if="currentMenu === '1'" class="face-library-page">
          <!-- 原有代码不变 -->
          <div class="search-bar">
            <el-input
              placeholder="请输入人员姓名/身份证号"
              prefix-icon="Search"
              size="small"
              class="search-input"
              v-model="searchParams.keyword"
              @keyup.enter="handleSearch"
            />
            <el-button type="primary" size="small" @click="handleSearch">
              查询
            </el-button>
            <el-button type="info" size="small" @click="resetSearch">
              重置
            </el-button>
          </div>

          <el-table
            :data="faceLibraryList"
            border
            size="small"
            class="data-table"
            v-loading="loading"
          >
            <el-table-column type="selection" width="50" />
            <el-table-column prop="name" label="人员姓名" />
            <el-table-column prop="idCard" label="编号" />
            <el-table-column prop="faceType" label="人脸">
              <template #default="scope">
                <img :src="scope.row.faceUrl" alt="人脸" height="100px" />
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="录入时间" />
            <el-table-column prop="status" label="状态" width="100">
              <template #default="scope">
                <el-tag
                  :type="scope.row.status === '1' ? 'success' : 'warning'"
                >
                  {{ scope.row.status === "1" ? "启用" : "禁用" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="View"
                  @click="viewFaceDetail(scope.row)"
                >
                  查看
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Edit"
                  @click="editFace(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Delete"
                  @click="deleteFace(scope.row)"
                  style="color: #ff4d4f"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 设备管理页面 -->
        <div v-if="currentMenu === '2'" class="device-page">
          <!-- 原有代码不变 -->
          <div class="search-bar">
            <el-input
              placeholder="请输入设备名称/设备编号"
              prefix-icon="Search"
              size="small"
              class="search-input"
              v-model="deviceSearchParams.keyword"
              @keyup.enter="searchDevice"
            />
            <el-select
              placeholder="请选择设备类型"
              size="small"
              class="search-select"
              v-model="deviceSearchParams.deviceType"
            >
              <el-option label="摄像头" value="1"></el-option>
              <el-option label="作业记录仪" value="2"></el-option>
              <el-option label="人脸识别终端" value="3"></el-option>
            </el-select>
            <el-select
              placeholder="请选择在线状态"
              size="small"
              class="search-select"
              v-model="deviceSearchParams.onlineStatus"
            >
              <el-option label="在线" value="1"></el-option>
              <el-option label="离线" value="0"></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="searchDevice">
              查询
            </el-button>
            <el-button type="info" size="small" @click="resetDeviceSearch">
              重置
            </el-button>
          </div>

          <el-table
            :data="deviceList"
            border
            size="small"
            class="data-table"
            v-loading="loading"
          >
            <el-table-column type="selection" width="50" />
            <el-table-column prop="deviceName" label="设备名称" />
            <el-table-column prop="deviceCode" label="设备编号" />
            <el-table-column prop="deviceType" label="设备类型">
              <template #default="scope">
                <el-tag type="primary">
                  {{
                    scope.row.deviceType === "1"
                      ? "摄像头"
                      : scope.row.deviceType === "2"
                      ? "作业记录仪"
                      : "人脸识别终端"
                  }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="location" label="安装位置" />
            <el-table-column prop="onlineStatus" label="在线状态" width="100">
              <template #default="scope">
                <el-tag
                  :type="scope.row.onlineStatus === '1' ? 'success' : 'danger'"
                >
                  {{ scope.row.onlineStatus === "1" ? "在线" : "离线" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="lastOnlineTime"
              label="最后在线时间"
              width="180"
            />
            <el-table-column label="操作" width="300">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="Setting"
                  @click="configDevice(scope.row)"
                >
                  配置
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Edit"
                  @click="editDevice(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Delete"
                  @click="deleteDevice(scope.row)"
                  style="color: #ff4d4f"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 角色管理页面 -->
        <div v-if="currentMenu === '3'" class="role-page">
          <!-- 原有代码不变 -->
          <el-table
            :data="roleList"
            border
            size="small"
            class="data-table"
            v-loading="loading"
          >
            <el-table-column type="selection" width="50" />
            <el-table-column prop="roleName" label="角色名称" />
            <el-table-column prop="roleCode" label="角色编码" />
            <el-table-column
              prop="description"
              label="角色描述"
              min-width="200"
            />
            <el-table-column prop="userCount" label="关联用户数" width="100" />
            <el-table-column prop="createTime" label="创建时间" />
            <el-table-column label="操作" width="300">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="Lock"
                  @click="setRolePerm(scope.row)"
                >
                  权限设置
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Edit"
                  @click="editRole(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Delete"
                  @click="deleteRole(scope.row)"
                  style="color: #ff4d4f"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 用户管理页面 -->
        <div v-if="currentMenu === '4'" class="user-page">
          <!-- 原有代码不变 -->
          <div class="search-bar">
            <el-input
              placeholder="请输入用户名/姓名/手机号"
              prefix-icon="Search"
              size="small"
              class="search-input"
              v-model="userSearchParams.keyword"
              @keyup.enter="searchUser"
            />
            <el-select
              placeholder="请选择角色"
              size="small"
              class="search-select"
              v-model="userSearchParams.roleId"
            >
              <el-option label="管理员" value="1"></el-option>
              <el-option label="操作员" value="2"></el-option>
              <el-option label="查看员" value="3"></el-option>
            </el-select>
            <el-select
              placeholder="请选择状态"
              size="small"
              class="search-select"
              v-model="userSearchParams.status"
            >
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="searchUser">
              查询
            </el-button>
            <el-button type="info" size="small" @click="resetUserSearch">
              重置
            </el-button>
          </div>

          <el-table
            :data="userList"
            border
            size="small"
            class="data-table"
            v-loading="loading"
          >
            <el-table-column type="selection" width="50" />
            <el-table-column prop="username" label="用户名" />
            <el-table-column prop="realName" label="真实姓名" />
            <el-table-column prop="phone" label="手机号" />
            <el-table-column prop="roleName" label="所属角色" />
            <el-table-column prop="deptName" label="所属部门" />
            <el-table-column prop="status" label="状态" width="100">
              <template #default="scope">
                <el-tag
                  :type="scope.row.status === '1' ? 'success' : 'warning'"
                >
                  {{ scope.row.status === "1" ? "启用" : "禁用" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="lastLoginTime"
              label="最后登录时间"
              width="180"
            />
            <el-table-column label="操作" width="300">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="Key"
                  @click="resetPwd(scope.row)"
                >
                  重置密码
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Edit"
                  @click="editUser(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Delete"
                  @click="deleteUser(scope.row)"
                  style="color: #ff4d4f"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 新增区域管理页面 -->
        <div v-if="currentMenu === '5'" class="area-page">
          <!-- 区域搜索筛选 -->
          <div class="search-bar">
            <el-input
              placeholder="请输入区域名称/区域编码"
              prefix-icon="Search"
              size="small"
              class="search-input"
              v-model="areaSearchParams.keyword"
              @keyup.enter="searchArea"
            />
            <el-select
              placeholder="请选择区域级别"
              size="small"
              class="search-select"
              v-model="areaSearchParams.areaLevel"
            >
              <el-option label="一级区域" value="1"></el-option>
              <el-option label="二级区域" value="2"></el-option>
              <el-option label="三级区域" value="3"></el-option>
            </el-select>
            <el-select
              placeholder="请选择状态"
              size="small"
              class="search-select"
              v-model="areaSearchParams.status"
            >
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="searchArea">
              查询
            </el-button>
            <el-button type="info" size="small" @click="resetAreaSearch">
              重置
            </el-button>
          </div>

          <!-- 区域列表 -->
          <el-table
            :data="areaList"
            border
            size="small"
            class="data-table"
            v-loading="loading"
          >
            <el-table-column type="selection" width="50" />
            <el-table-column prop="areaName" label="区域名称" />
            <el-table-column prop="areaCode" label="区域编码" />
            <el-table-column prop="parentAreaName" label="上级区域" />
            <el-table-column prop="areaLevel" label="区域级别">
              <template #default="scope">
                <el-tag
                  :type="
                    scope.row.areaLevel === '1'
                      ? 'primary'
                      : scope.row.areaLevel === '2'
                      ? 'success'
                      : 'info'
                  "
                >
                  {{
                    scope.row.areaLevel === "1"
                      ? "一级区域"
                      : scope.row.areaLevel === "2"
                      ? "二级区域"
                      : "三级区域"
                  }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="sortNum" label="排序号" width="100" />
            <el-table-column prop="status" label="状态" width="100">
              <template #default="scope">
                <el-tag
                  :type="scope.row.status === '1' ? 'success' : 'warning'"
                >
                  {{ scope.row.status === "1" ? "启用" : "禁用" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180" />
            <el-table-column label="操作" width="300">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="View"
                  @click="viewArea(scope.row)"
                >
                  查看
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Edit"
                  @click="editArea(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="Delete"
                  @click="deleteArea(scope.row)"
                  style="color: #ff4d4f"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, reactive, computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  UserFilled,
  Monitor,
  UserRole,
  User,
  Plus,
  Upload,
  Refresh,
  Search,
  View,
  Edit,
  Delete,
  Setting,
  Lock,
  Key,
} from "@element-plus/icons-vue";

// 当前选中的菜单
const currentMenu = ref("1");

// 菜单标题映射（新增区域管理）
const currentTitle = computed(() => {
  const titleMap = {
    1: "人脸库管理",
    2: "设备管理",
    3: "角色管理",
    4: "用户管理",
    5: "区域管理", // 新增
  };
  return titleMap[currentMenu.value];
});

// 加载状态
const loading = ref(false);

// ===================== 人脸库管理相关 =====================
const searchParams = reactive({
  keyword: "",
  faceType: "",
});
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(128);
const faceLibraryList = ref([
  {
    name: "习**",
    idCard: "110101199001011234",
    faceType: "1",
    createTime: "2026-03-01 10:23:45",
    status: "1",
    faceUrl: require("../assets/images/xi.jpg"),
  },
  {
    name: "袁**",
    idCard: "110101199002021234",
    faceType: "2",
    createTime: "2026-03-02 14:15:22",
    status: "1",
    faceUrl: require("../assets/images/yuan.png"),
  },
  {
    name: "奥**",
    idCard: "110101199003031234",
    faceType: "3",
    createTime: "2026-03-03 09:08:15",
    status: "0",
    faceUrl: require("../assets/images/ao.jpg"),
  },
]);
const handleSearch = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    ElMessage.success("查询成功");
  }, 500);
};
const resetSearch = () => {
  searchParams.keyword = "";
  searchParams.faceType = "";
};
const handleSizeChange = (val) => {
  pageSize.value = val;
};
const handleCurrentChange = (val) => {
  currentPage.value = val;
};
const viewFaceDetail = (row) => {
  ElMessage.info(`查看人脸信息：${row.name}`);
};
const editFace = (row) => {
  ElMessage.info(`编辑人脸信息：${row.name}`);
};
const deleteFace = (row) => {
  ElMessageBox.confirm(`确定要删除【${row.name}】的人脸信息吗？`, "删除确认", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      ElMessage.success("删除成功");
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};
const handleImportFace = () => {
  ElMessage.info("批量导入人脸库功能开发中");
};

// ===================== 设备管理相关 =====================
const deviceSearchParams = reactive({
  keyword: "",
  deviceType: "",
  onlineStatus: "",
});
const deviceCurrentPage = ref(1);
const devicePageSize = ref(10);
const deviceTotal = ref(86);
const deviceList = ref([
  {
    deviceName: "北门摄像头",
    deviceCode: "CAM-001",
    deviceType: "1",
    location: "北门入口处",
    onlineStatus: "1",
    lastOnlineTime: "2026-03-03 15:20:30",
  },
  {
    deviceName: "作业记录仪001",
    deviceCode: "REC-001",
    deviceType: "2",
    location: "作业一队",
    onlineStatus: "0",
    lastOnlineTime: "2026-03-02 18:10:25",
  },
  {
    deviceName: "人脸识别终端01",
    deviceCode: "FACE-001",
    deviceType: "3",
    location: "办公楼大厅",
    onlineStatus: "1",
    lastOnlineTime: "2026-03-03 15:25:40",
  },
]);
const searchDevice = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    ElMessage.success("设备查询成功");
  }, 500);
};
const resetDeviceSearch = () => {
  deviceSearchParams.keyword = "";
  deviceSearchParams.deviceType = "";
  deviceSearchParams.onlineStatus = "";
};
const handleDeviceSizeChange = (val) => {
  devicePageSize.value = val;
};
const handleDeviceCurrentChange = (val) => {
  deviceCurrentPage.value = val;
};
const configDevice = (row) => {
  ElMessage.info(`配置设备：${row.deviceName}`);
};
const editDevice = (row) => {
  ElMessage.info(`编辑设备：${row.deviceName}`);
};
const deleteDevice = (row) => {
  ElMessageBox.confirm(`确定要删除设备【${row.deviceName}】吗？`, "删除确认", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      ElMessage.success("设备删除成功");
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

// ===================== 角色管理相关 =====================
const roleCurrentPage = ref(1);
const rolePageSize = ref(10);
const roleTotal = ref(15);
const roleList = ref([
  {
    roleName: "系统管理员",
    roleCode: "ADMIN",
    description: "系统最高权限管理员",
    userCount: 2,
    createTime: "2026-01-01 09:00:00",
  },
  {
    roleName: "安全管理员",
    roleCode: "SAFE_ADMIN",
    description: "负责安全管控相关操作",
    userCount: 8,
    createTime: "2026-01-05 10:30:00",
  },
  {
    roleName: "普通操作员",
    roleCode: "OPERATOR",
    description: "日常作业操作",
    userCount: 24,
    createTime: "2026-01-10 14:20:00",
  },
]);
const handleRoleSizeChange = (val) => {
  rolePageSize.value = val;
};
const handleRoleCurrentChange = (val) => {
  roleCurrentPage.value = val;
};
const setRolePerm = (row) => {
  ElMessage.info(`设置【${row.roleName}】权限`);
};
const editRole = (row) => {
  ElMessage.info(`编辑角色：${row.roleName}`);
};
const deleteRole = (row) => {
  ElMessageBox.confirm(
    `确定要删除角色【${row.roleName}】吗？删除后关联用户将失去该角色权限。`,
    "删除确认",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    },
  )
    .then(() => {
      ElMessage.success("角色删除成功");
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

// ===================== 用户管理相关 =====================
const userSearchParams = reactive({
  keyword: "",
  roleId: "",
  status: "",
});
const userCurrentPage = ref(1);
const userPageSize = ref(10);
const userTotal = ref(56);
const userList = ref([
  {
    username: "admin",
    realName: "系统管理员",
    phone: "13800138000",
    roleName: "管理员",
    deptName: "技术部",
    status: "1",
    lastLoginTime: "2026-03-03 08:30:15",
  },
  {
    username: "operator01",
    realName: "张作业",
    phone: "13800138001",
    roleName: "操作员",
    deptName: "作业一队",
    status: "1",
    lastLoginTime: "2026-03-03 09:15:20",
  },
  {
    username: "viewer01",
    realName: "李查看",
    phone: "13800138002",
    roleName: "查看员",
    deptName: "安全部",
    status: "0",
    lastLoginTime: "2026-02-28 16:40:30",
  },
]);
const searchUser = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    ElMessage.success("用户查询成功");
  }, 500);
};
const resetUserSearch = () => {
  userSearchParams.keyword = "";
  userSearchParams.roleId = "";
  userSearchParams.status = "";
};
const handleUserSizeChange = (val) => {
  userPageSize.value = val;
};
const handleUserCurrentChange = (val) => {
  userCurrentPage.value = val;
};
const resetPwd = (row) => {
  ElMessageBox.confirm(
    `确定要重置【${row.realName}】的密码吗？默认密码为123456`,
    "重置密码",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    },
  )
    .then(() => {
      ElMessage.success("密码重置成功，默认密码：123456");
    })
    .catch(() => {
      ElMessage.info("已取消重置");
    });
};
const editUser = (row) => {
  ElMessage.info(`编辑用户：${row.realName}`);
};
const deleteUser = (row) => {
  ElMessageBox.confirm(`确定要删除用户【${row.realName}】吗？`, "删除确认", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      ElMessage.success("用户删除成功");
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

// ===================== 区域管理相关（新增） =====================
// 区域搜索参数
const areaSearchParams = reactive({
  keyword: "",
  areaLevel: "",
  status: "",
});

// 区域分页参数
const areaCurrentPage = ref(1);
const areaPageSize = ref(10);
const areaTotal = ref(42);

// 区域列表模拟数据
const areaList = ref([
  {
    areaName: "北京市",
    areaCode: "110000",
    parentAreaName: "无",
    areaLevel: "1",
    sortNum: 1,
    status: "1",
    createTime: "2026-01-01 09:00:00",
  },
  {
    areaName: "北京市海淀区",
    areaCode: "110108",
    parentAreaName: "北京市",
    areaLevel: "2",
    sortNum: 2,
    status: "1",
    createTime: "2026-01-02 10:00:00",
  },
  {
    areaName: "海淀区中关村街道",
    areaCode: "110108001",
    parentAreaName: "北京市海淀区",
    areaLevel: "3",
    sortNum: 3,
    status: "0",
    createTime: "2026-01-03 11:00:00",
  },
]);

// 区域搜索
const searchArea = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    ElMessage.success("区域查询成功");
  }, 500);
};

// 重置区域搜索
const resetAreaSearch = () => {
  areaSearchParams.keyword = "";
  areaSearchParams.areaLevel = "";
  areaSearchParams.status = "";
};

// 区域分页处理
const handleAreaSizeChange = (val) => {
  areaPageSize.value = val;
};

const handleAreaCurrentChange = (val) => {
  areaCurrentPage.value = val;
};

// 区域操作方法
const viewArea = (row) => {
  ElMessage.info(`查看区域：${row.areaName}`);
};

const editArea = (row) => {
  ElMessage.info(`编辑区域：${row.areaName}`);
};

const deleteArea = (row) => {
  ElMessageBox.confirm(
    `确定要删除区域【${row.areaName}】吗？删除后该区域下的子区域也将被删除。`,
    "删除确认",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    },
  )
    .then(() => {
      ElMessage.success("区域删除成功");
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

// ===================== 通用方法 =====================
const handleMenuSelect = (index) => {
  currentMenu.value = index;
};
const handleAdd = () => {
  const addMap = {
    2: "设备",
    3: "角色",
    4: "用户",
    5: "区域", // 新增
  };
  ElMessage.info(`新增${addMap[currentMenu.value]}功能开发中`);
};
const handleRefresh = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    ElMessage.success("数据刷新成功");
  }, 500);
};
</script>

<style lang="scss" scoped>
// 原有样式不变
.admin-layout {
  height: 100%;
  background-color: #0a1020;
  color: #e5e9f0;

  .sidebar {
    width: 200px;
    background: linear-gradient(180deg, #0f1a30 0%, #050b1a 100%);
    border-right: 1px solid #1a3a6a;
    display: flex;
    flex-direction: column;

    .sidebar-logo {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #1a3a6a;
      padding: 0 15px;

      .logo-icon {
        font-size: 24px;
        color: #00ccff;
        margin-right: 8px;
      }

      .logo-text {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        text-shadow: 0 0 10px rgba(0, 204, 255, 0.3);
      }
    }
    .el-menu {
      border-right: none;
    }
    .sidebar-menu {
      flex: 1;
      padding-top: 20px;

      :deep(.el-menu-item) {
        color: #b0c8e8;
        height: 48px;
        line-height: 48px;
        margin: 0 10px 5px;
        border-radius: 6px;
        padding-left: 20px !important;
        transition: all 0.3s ease;

        &:hover {
          background-color: rgba(0, 204, 255, 0.05);
          color: #00ccff;
        }

        &.is-active {
          background: linear-gradient(135deg, #0066cc 0%, #0099ff 100%);
          color: #ffffff !important;
          box-shadow: 0 0 10px rgba(0, 153, 255, 0.2);
        }
      }

      :deep(.el-menu-item-icon) {
        color: inherit;
        margin-right: 10px;
      }
    }
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;

    .content-header {
      height: 60px;
      background-color: #0f1a30;
      border-bottom: 1px solid #1a3a6a;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .content-title {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        margin: 0;
      }

      .content-actions {
        display: flex;
        gap: 10px;
      }
    }

    .content-body {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
      background-color: #0a1020;

      .search-bar {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        flex-wrap: wrap;

        .search-input {
          width: 280px;
        }

        .search-select {
          width: 180px;
        }
      }

      .data-table {
        --el-table-bg-color: #0f1a30 !important;
        --el-table-header-text-color: #ffffff !important;
        --el-table-row-hover-bg-color: #16325e !important;
        --el-table-text-color: #b0c8e8 !important;
        --el-table-border-color: #1a3a6a !important;
        --el-table-header-bg-color: #14305c !important;

        :deep(.el-table__header-wrapper) {
          th {
            background-color: #14305c !important;
            color: #ffffff !important;
            border-bottom-color: #1a3a6a !important;
          }
        }

        :deep(.el-table__body-wrapper) {
          td {
            background-color: #0f1a30 !important;
            color: #b0c8e8 !important;
            border-bottom-color: #1a3a6a !important;
          }
        }

        :deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
          background-color: #16325e !important;
          color: #ffffff !important;
        }
      }
    }
  }
}

:deep {
  .el-input {
    --el-input-bg-color: #14305c;
    --el-input-border-color: #1a3a6a;
    --el-input-text-color: #ffffff;
    --el-input-placeholder-color: #8aa2c2;
    --el-input-hover-border-color: #00ccff;
  }

  .el-select__wrapper {
    background-color: #14305c;
    box-shadow: 0 0 0 1px #1a3a6a inset;
  }
}
</style>
